<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
</style>

<template>
  <div>
    <div class="d-flex justify-content-between" style="margin-bottom: 10px">
      <div>
        <p style="font-size: 12px">
          <b-icon icon="info" variant="success"></b-icon>&nbsp;Select table row
          for more option.
        </p>
      </div>
      <b-button-group v-if="editableOps">
        <b-button
          variant="outline-primary"
          size="sm"
          @click="refreshGrid"
          >Refresh</b-button
        >
      </b-button-group>
    </div>
    Data definition problem
    <DxDataGrid
      id="fishing-wellbore-grid"
      ref="fishingWellboreGrid"
      :data-source="fishingWellObstructionDataSource"
      :show-borders="false"
      :show-column-lines="false"
      :show-row-lines="true"
      column-resize-mode="nextColumn"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :cell-hint-enabled="true"
      :word-wrap-enabled="true"
      :column-auto-width="false"
      :column-width="100"
      :height="300"
      @row-inserted="savedRows"
      @row-updated="updatedRows"
      @row-removed="removedRows"
    >
      <DxPaging :enabled="false"/>
      <DxSelection mode="single"/>
      <DxScrolling column-rendering-mode="virtual"/>
      <DxEditing
          :allow-updating="true"
          :allow-adding="true"
          :allow-deleting="true"
          :use-icons="true"
          mode="row"/>
      <DxColumn v-for="column in tableFields" :key="column.key" :data-field="column.key" :caption="column.label" :data-type="column.type" />
    </DxDataGrid>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxEditing,
  DxFormItem,
  DxLookup,
  DxSelection,
  DxScrolling
} from 'devextreme-vue/data-grid'
import notify from "devextreme/ui/notify"
import { formMethods } from '@state/helpers'
import CustomStore from 'devextreme/data/custom_store'
import mapApiUrl from '@/src/utils/api-mapper'
import axios from 'axios'
import qs from 'querystring'

export default {
  components: { 
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxSelection,
    DxScrolling,
    // DxFormItem,
    DxLookup,
    // DxForm,
    // DxSimpleItem,
    // DxGroupItem,
  },
  props: {
    submitId: {
      type: Number,
      default: undefined,
    },
    editableOps: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      fishingWellObstructionDataSource: null,
      selectedRow: [],
      listItem: [],
      perPage: 10,
      tableBusy: false,
      currentPage: 1,
      tableFields: [
        { key: 'stringType', label: 'String type', type: 'string' },
        { key: 'type', label: 'Type', type: 'string' },
        { key: 'dateTime', label: 'Date time', type: 'datetime' },
        { key: 'description', label: 'Description', type: 'string' },
        { key: 'mdTop', label: 'MD top', type: 'number' },
        { key: 'mdBase', label: 'MD base', type: 'number'},
        { key: 'topOd', label: 'Top OD', type: 'number'},
        { key: 'topId', label: 'Top ID', type: 'number'},
        { key: 'fishingNeckDescription', label: 'Fishing Neck Description', type: 'string' },
        { key: 'comments', label: 'Comments', type: 'string' },
        { key: 'obstructionNo', label: 'Obstruction No.', type: 'number'},
        { key: 'obstructionSubcode', label: 'Obstruction Subcode 1', type: 'string' },
        { key: 'obstructionSubcode2', label: 'Obstruction Subcode 2', type: 'string' },
        { key: 'tubular', label: 'Tubular', type: 'boolean'},
        { key: 'status', label: 'Status', type: 'string' },
        { key: 'date', label: 'Date', type: 'date' },
        { key: 'reason', label: 'Reason', type: 'string' },
        { key: 'fishingMethod', label: 'Fishing Method', type: 'string' },
        { key: 'fishingToolDesc', label: 'Fishing tool desc', type: 'string' },
        { key: 'restrictionId', label: 'Restriction ID', type: 'number' },
        { key: 'topOdStatus', label: 'Top OD', type: 'number' },
        { key: 'topIdStatus', label: 'Top ID', type: 'number' },
        { key: 'mdTopStatus', label: 'MD top', type: 'number' },
        { key: 'mdBaseStatus', label: 'MD base', type: 'number' },
        { key: 'fillDebrisOnTop', label: 'Fill Debris on top', type: 'boolean' },
        { key: 'mdFillTop', label: 'MD fill top', type: 'number' },
        { key: 'retrievalAttempted', label: 'Retrieval attempted', type: 'boolean' },
        { key: 'commentsStatus', label: 'Comments', type: 'string' },
        { key: 'stuckReason', label: 'Stuck reason', type: 'string' },
        { key: 'remarks', label: 'Remarks', type: 'string' },

      ],
      selectedAction: '',
      form: [],
      show: false,
      optionComboStringType: [],
      optionComboType: [],
      optionComboDesc: [],
      optionComboObsSubcode: [],
      optionComboObsSubcode2: [],
      optionComboStatus: [],
      optionWellboreDescription: [],
    }
  },

  computed: {
    totalRows: function () {
      return this.listItem.length
    },
  },

  watch: {
    submitId: function (val) {
      this.refreshGrid()
    },
  },

  created: function () {
    this.init()
    this.loadAllCombo()
  },

  methods: {
    ...formMethods,
    init() {
      this.fishingWellObstructionDataSource = new CustomStore({
        key: 'intId',
        load: () => {
          const url = mapApiUrl('/api/form/activity/fishing/wellboreobstruction/review/submit')
          const params = {submitId: this.submitId, status: 1}
          return axios.get(url, {params: params}).then(response => response.data.data)
        },
        onLoaded: (result) => {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0])
            }
        },
        insert: (values) => {
          values.submitId = this.submitId
          const url = mapApiUrl('/api/form/activity/fishing/wellboreobstruction/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        update: (key, values) => {
          values.submitId = this.submitId
          values.intId = key
          const url = mapApiUrl('/api/form/activity/fishing/wellboreobstruction/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        remove: (key) => {
          const url = mapApiUrl('/api/form/activity/fishing/wellboreobstruction/remove')
          return axios.delete(url, {params: {intId: key}})
        },
      })
    },
    refreshGrid() {
      this.$refs.fishingWellboreGrid.instance.refresh()
    },
    savedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Wellbore obstruction data has been recorded.`, width: 500 }, 'success', 3000)
    },
    updatedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Wellbore obstruction data has been updated.`, width: 500 }, 'success', 3000)
    },
    removedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Wellbore obstruction data has been removed.`, width: 500 }, 'success', 3000)
    },
    refreshTableAndCombo() {
      this.listItem = []
      if (this.submitId) {
        this.tableBusy = true
        this.getActivityFishingWellboreObstruction({
          params: { submitId: this.submitId },
        }).then((resp) => {
          this.listItem = resp.data.data
          this.tableBusy = false
        })
      } else {
        console.log('No report selected')
      }
    },
    loadAllCombo() {
      this.optionComboStringType = []
      this.optionComboDesc = []
      this.optionComboObsSubcode = []
      this.optionComboObsSubcode2 = []
      this.optionComboStatus = []
      this.optionWellboreDescription = []

      let dataCombo = [
        { option: 1, combo_name: 'string_type', ref_id: '' },
        { option: 2, combo_name: 'obstruction_type', ref_id: '' },
        { option: 3, combo_name: 'obstruction_desc', ref_id: '' },
        { option: 4, combo_name: 'obstruction_subcode', ref_id: '' },
        { option: 5, combo_name: 'obstruction_subcode_2', ref_id: '' },
        { option: 6, combo_name: 'obstruction_status', ref_id: '' },
        { option: 7, combo_name: 'obstruction_desc', ref_id: '' },
      ]

      dataCombo.forEach((data) => {
        this.getComboOptionList({
          params: {
            form_id: 'fishing',
            combo_name: data.combo_name,
            ref_id: data.ref_id,
          },
        }).then((resp) => {
          resp.data.data.forEach((d) => {
            switch (data.option) {
              case 1:
                this.optionComboStringType.push({
                  value: d.comboId,
                  text: d.comboValue,
                })
                break
              case 2:
                this.optionComboType.push({
                  value: d.comboId,
                  text: d.comboValue,
                })
                break
              case 3:
                this.optionComboDesc.push({
                  value: d.comboId,
                  text: d.comboValue,
                })
                break
              case 4:
                this.optionComboObsSubcode.push({
                  value: d.comboId,
                  text: d.comboValue,
                })
                break
              case 5:
                this.optionComboObsSubcode2.push({
                  value: d.comboId,
                  text: d.comboValue,
                })
                break
              case 6:
                this.optionComboStatus.push({
                  value: d.comboId,
                  text: d.comboValue,
                })
                break
              case 7:
                this.optionWellboreDescription.push({
                  value: d.comboId,
                  text: d.comboValue,
                })
                break
              default:
                break
            }
          })
        })
      })
    },
    onRowSelected(item) {
      if (item.length === 0) {
        this.selectedRow = []
        this.$refs.tableDataFWo.clearSelected()
        return
      }
      this.selectedRow = item
      this.form = item[0]
    },
    makeToast(msg) {
      this.$bvToast.toast(msg, {
        title: 'Notification',
        autoHideDelay: 5000,
        appendToast: false,
      })
    },
    saving(e) {
      let rowData = {}
      if (Array.isArray(e.changes)) {
        rowData = {...e.changes[0].data}        
      } else {
        rowData = {...e.changes.data}
      }
      delete rowData.intId
      rowData.submitId = this.submitId
      this.addActivityFishingWellboreObstruction({ params: rowData }).then((resp) => {
          this.retrieveDataTable()
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
      })
    },
    askServerToRemoveData() {
      if (this.selectedRow.length > 0) {
        const data = { ...this.selectedRow[0] }
        this.removeActivityFishingWellboreObstruction({ params: data }).then(
          (resp) => {
            this.refreshTableAndCombo()
            this.closeModalRemove()
            this.makeToast('Remove data logging intervals details success.')
          }
        )
      }
    },
  },
}
</script>